<template>
    <div class="container-fluid">
        <div id="accordion">
            <div class="card">
                <div class="card-header" v-on:click="show = !show">
                    <div class="row mb-3 px-3">
                        <div>
                            <button class="all-btn add-btn">{{$t("main.search")}} .... </button>
                        </div>
                        <div class="px-3">
                            <p style="color: #18ce0f">
                                <button class="all-btn" @click.prevent="reportXslx()" v-if="hasPermission('ACCOUNTING_EXCEL_REPORT')">
                                    {{$t("accounting.account.report")}}
                                </button>
                            </p>
                        </div>
                        <div v-if="vatPay.evaluationObjectIds.length>0">
                            <button class="all-btn" @click.prevent="openVatPaymentModal" v-if="hasPermission('ACCOUNTING_PAYMENT_VAT_INPUT')">
                                {{$t("accounting.account.vatEnterPayment")}}
                            </button>
                        </div>
                    </div>
                </div>

                <div v-if="show" id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-lg-2 col-md-3 col-sm-4" v-if="organizationListValue.data && organizationListValue.data.length > 0">
                                <label>{{$t("accounting.account.organization")}}</label>
                                <select class="form-control" v-model="filter.organizationType"
                                        @change="onOrganizationTypeChange">
                                    <option value="" v-if="organizationListValue.data.length === organizationListValue.total"></option>
                                    <option :value="option.code" v-for="option in organizationListValue.data"
                                            :key="option.code">
                                        {{option.displayName}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.province")}}</label>
                                <v-select v-model="filter.province" label="name"
                                          :options="provinces"
                                          :filterable="false"
                                          :disabled="regionalLeaderProvince!=null"
                                          @search="onProvinceGetRegionsChange"
                                          @change="onProvinceGetRegionsChange">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>

                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.city")}} ва
                                    {{$t("accounting.account.district")}}</label>
                                <v-select v-model="filter.region" label="name"
                                          :options="regions"
                                          :filterable="false"
                                          @search="searchByFilter"
                                          @change="searchByFilter">
                                    <template slot="option" slot-scope="option" v-if="option">
                                        <div v-html="option.name"></div>
                                    </template>
                                    <span slot="no-options">{{$t("messages.combo.empty")}}</span>
                                </v-select>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4" v-if="filter.province">
                                <label>Ким томонидан яратилган <span class="font-weight-bold" style="font-size: 8px; color: red">(фойдаланувчининг вилоят, шаҳар, туман нисбатан)</span></label>
                                <br/>
                                <div>
<!--                                  <input type="checkbox" style="transform : scale(2); " v-model="filter.placeCreation"
                                         :disabled="regionalLeaderProvince!=null"/>-->
                                  <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" :id="'placeCreation' + regionalLeaderProvince" :disabled="regionalLeaderProvince!=null"
                                           v-model="filter.placeCreation"
                                    />
                                    <label class="custom-control-label" :for="'placeCreation' + regionalLeaderProvince"></label>
                                  </div>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.date.startDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.startDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.date.endDate")}}</label>
                                <datepicker
                                        class="form-control"
                                        format="dd/MM/yyyy"
                                        v-model="filter.endDate"
                                        :clear-button="true"
                                ></datepicker>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.executiveJob")}}
                                    {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.letterNumber" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.contract")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.generateNumberContract" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.invoice")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.invoiceNumber" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.report")}} {{$t("accounting.account.number")}}</label>
                                <input type="text" class="form-control" v-model="filter.generateNumberReport" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.identificationNumber")}}</label>
                                <input type="text" class="form-control" v-model="filter.identificationNumber" @change="searchByFilter"/>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.fullName")}} yoki
                                    {{$t("accounting.account.organization")}}</label>
                                <input type="text" class="form-control" v-model="filter.search" @change="searchByFilter"/>
                            </div>
                            <!--<div class="col-lg-2 col-md-3 col-sm-4">-->
                                <!--<label>{{$t("report.field.pays")}}<br/>-->
                                    <!--<input type="checkbox" v-model="filter.paid"/>-->
                                <!--</label>-->
                            <!--</div>-->
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("report.field.paymentStatus")}}</label>
                                <select class="form-control" v-model="filter.paymentStatus">
                                    <option value="ALL">{{$t('report.field.paymentStatusAll')}}</option>
                                    <option value="PAID">{{$t('report.field.paymentStatusPaid')}}</option>
                                    <option value="UNPAID">{{$t('report.field.paymentStatusUnPaid')}}</option>
                                </select>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4">
                                <label>{{$t("accounting.account.source")}}</label>
                                <select class="form-control" v-model="filter.source">
                                    <option value="ALL">{{$t('report.field.paymentStatusAll')}}</option>
                                    <option value="ONLINE">{{$t('report.field.online')}}</option>
                                    <option value="INSIDE">{{$t('report.field.inside')}}</option>
                                    <option value="ANDROID">{{$t('report.field.android')}}</option>
                                    <option value="API_MIB">{{$t('report.field.api_mib')}}</option>
                                </select>
                            </div>
                            <div class="col-sm-1">
                                <label style="align-self: center">{{$t("main.search")}}</label>
                                <button class="all-btn form-control" @click="searchByFilter"
                                        style="color: #fff;background-color: #00bcd4;border-color: #00bcd4;
                                        box-shadow: 0 2px 2px 0 rgba(0, 188, 212, .14),
                                        0 3px 1px -2px rgba(0, 188, 212, .2),
                                        0 1px 5px 0 rgba(0, 188, 212, .12)">
                                    <i class="fa fa-filter"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <vat-payment-modal></vat-payment-modal>
                    <div class="card-body scroll-card-body">
                        <table class="customers">
                            <thead>
                            <tr>
                                <th rowspan="3">№</th>
                                <th rowspan="3">{{$t('accounting.account.createdUserName')}}</th>
                                <th colspan="9">{{organization}}</th>
                                <th colspan="3">{{$t("accounting.account.order")}}</th>
                                <th colspan="3">{{$t("accounting.account.report")}}</th>
                                <th colspan="8">{{$t("accounting.account.invoice")}}</th>
                                <th rowspan="3">{{$t("accounting.account.totalAmountQQS")}}</th>
                                <th colspan="6">{{$t("accounting.account.paymentDocument")}}</th>
                                <th rowspan="3">{{$t("accounting.account.vatPayment")}}</th>
                                <th colspan="2">{{$t("accounting.account.debtBalance")}}</th>
                            </tr>
                            <tr>
                                <th rowspan="2">{{$t("accounting.account.province")}}</th>
                                <th rowspan="2">{{$t("accounting.account.city")}}{{$t("accounting.account.district")}}</th>
                                <th rowspan="2">{{$t("accounting.account.fullName")}}</th>
                                <th rowspan="2">{{$t("accounting.account.passportNumber")}}</th>
                                <th colspan="2">{{$t("accounting.account.executiveJob")}}</th>
                                <th rowspan="2">{{$t("accounting.account.identificationNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.bankMFO")}}</th>
                                <th rowspan="2">{{$t("accounting.account.accountNumber")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.source")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.feeService")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.jobName")}}</th>
                                <th rowspan="2">{{$t("accounting.account.priceWithoutQQS")}}</th>
                                <th colspan="2">{{$t("accounting.account.qqs")}}</th>
                                <th rowspan="2">{{$t("accounting.account.esp")}}  {{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.esp")}}  {{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.date")}}</th>
                                <th rowspan="2">{{$t("accounting.account.number")}}</th>
                                <th rowspan="2">{{$t("accounting.account.amountPrice")}}</th>
                                <th rowspan="2">{{$t("accounting.account.paymentSource")}}</th>
                                <th rowspan="2">{{$t("accounting.account.registrationPayDoc")}}</th>
                                <th rowspan="2">{{$t("accounting.account.registrationPayDoc")}}</th>
                                <th rowspan="2">{{$t("accounting.account.debtor")}}</th>
                                <th rowspan="2">{{$t("accounting.account.creditor")}}</th>
                            </tr>
                            <tr>
                                <th>{{$t("accounting.account.date")}}</th>
                                <th>{{$t("accounting.account.number")}}</th>
                                <th>{{$t("accounting.account.qqsRate")}}</th>
                                <th>{{$t("accounting.account.qqsAmount")}}</th>
                            </tr>

                            </thead>
                            <tbody>
                            <template v-if="results">
                                <tr v-for=" (result) in results.data" :key="result.id">
                                    <td> <a :href="getOpenLink(result)" target="_blank">{{result.id}}</a></td>
                                    <td>
                                        <span class="">
                                            {{result.createdBy!=null?result.createdBy.name:''}}
                                        </span><br/>
                                        <span class="font-weight-bold small">
                                            <b>{{result.createdUserRoleName}}</b>
                                        </span> <br/>
                                        <span class="font-weight-bold font-italic" style="font-size: 10px; color: red">
                                            {{result.createdBy.region!=null && result.createdBy.region.provinceDto!=null?result.createdBy.region.provinceDto.name:''}}
                                        </span><br/>
                                        <span class="font-weight-bold font-italic" style="font-size: 10px; color: #0b75c9">
                                            {{result.createdBy.region!=null?result.createdBy.region.name:''}}
                                        </span>
                                    </td>
                                    <td>{{result.province}}</td>
                                    <td>{{result.region}}</td>
                                    <td>
                                        <div class="text-info">{{result.fullName}}</div>
                                        <div class="text-warning">{{result.firmName}}</div>
                                    </td>
                                    <td>{{result.passportNumber}}</td>
                                    <td>{{result.letterDate}}</td>
                                    <td>{{result.letterNumber}}</td>
                                    <td>{{result.identificationNumber}}</td>
                                    <td>{{result.bankMFO}}</td>
                                    <td>{{result.accountNumber}}</td>
                                    <td>{{result.generateDateContract}}</td>
                                    <td>{{result.generateNumberContract}}</td>
                                    <td class="text-center">
                                        <span v-if="result.entiteCreateType === 'API_MIB'" class="badge badge-success">{{result.entiteCreateType}}</span>
                                        <span v-else class="badge badge-primary">{{result.entiteCreateType}}</span>
                                    </td>
                                    <td>{{result.generateDateReport}}</td>
                                    <td>{{result.generateNumberReport}}</td>
                                    <td>{{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.generateDateReport}}</td>
                                    <td>{{result.generateNumberContract}}</td>
                                    <td>{{result.jobName}}</td>
                                    <td>{{result.contractAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.qqsRate | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.qqsAmount | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td><a href="AccountingLegalAndPhysical.vue"> {{result.espDate}}</a></td>
                                    <td><a href="AccountingLegalAndPhysical.vue"> {{result.espSerialNumber}}</a></td>
                                    <td>{{result.totalAmountQQS | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.paymentDocumentDate}}</td>
                                    <td>{{result.paymentDocumentNumber}}</td>
                                    <td>{{result.paid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.paymentSource}}</td>
                                    <td>
                                        <modal v-if="showModal">
                                            <h3 slot="header">{{$t("accounting.account.registrationPayDoc")}}</h3>
                                            <div slot="body">
                                                <div>
                                                    <label>{{$t("accounting.account.date")}}</label>
                                                    <datepicker
                                                            class="form-control"
                                                            format="dd/MM/yyyy"
                                                            v-model="newItem.paymentDocumentDate"
                                                            :clear-button="true"
                                                    ></datepicker>
                                                </div>
                                                <label>{{$t("accounting.account.totalAmount")}}</label>
                                                <numeric-input v-model="newItem.price" :precision="2" required></numeric-input>

                                                <label>{{$t("accounting.account.number")}}</label>
                                                <input type="text" class="form-control" id="paymentDocumentNumber"
                                                       name="paymentDocumentNumber"
                                                       v-model="newItem.paymentDocumentNumber" placeholder=" Раками"
                                                       required>
                                            </div>
                                            <div slot="footer" style="width: 100%;">
                                                <button style="float:right" type="button" class="all-btn delete-btn"
                                                        v-on:click="closeModal()"> Бекор қилиш
                                                </button>
                                                <button style="float:left" type="button" class="all-btn"
                                                        data-dismiss="modal"
                                                        v-on:click="saveModal()"> Сақлаш
                                                </button>
                                            </div>

                                        </modal>
                                        <button type="button" class="all-btn" v-on:click="openModal(result.id)" v-if="hasPermission('ACCOUNTING_PAYMENT_INPUT')">
                                            Киритиш
                                        </button>
                                    </td>
                                    <td>
                                        <modal v-if="showModalTable">
                                            <h3 slot="header">{{$t("accounting.account.registrationPayDocList")}}</h3>
                                            <div slot="body">
                                                <div class="card">
                                                    <div class="card-body">
                                                      <div class="table-wrapper">
                                                        <table class="table">
                                                            <thead class="modal-table-head">
                                                            <tr>
                                                                <th>
                                                                    № #
                                                                </th>
                                                                <th>
                                                                    {{$t("accounting.account.date")}}
                                                                </th>
                                                                <th>
                                                                    {{$t("accounting.account.number")}}
                                                                </th>
                                                                <th>
                                                                    {{$t("accounting.account.totalAmount")}}
                                                                </th>
                                                                <th  style="display: table-cell;">
                                                                    {{$t("realEstate.field.action")}}
                                                                </th>
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <template v-if="newItem">
                                                                <tr v-for="(it,index) in newItem" :key="it.id">
                                                                    <td>{{index+1}}</td>
                                                                    <td>{{format_date(it.paymentDocumentDate)}}</td>
                                                                    <td>{{it.paymentDocumentNumber}}</td>
                                                                    <td>{{it.price | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                                                    <td style="display: table-cell;">
                                                                        <button class="all-btn table-action edit-btn" data-original-title="Edit"
                                                                                @click="showPaymentDocumentEditModal(it)" v-if="it.evaluationPaymentSource==='MANUAL'">
                                                                            <i class="fa fa-edit"></i>
                                                                        </button>
                                                                    </td>

                                                                </tr>
                                                            </template>
                                                            </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div slot="footer" style="width: 100%;">
                                                <button style="float:right" type="button" class="all-btn delete-btn"
                                                        v-on:click="closeModalTable(result.id)">Бекор қилиш
                                                </button>
                                            </div>

                                        </modal>
                                        <button type="button" class="all-btn" v-if="hasPermission('ACCOUNTING_PAYMENT_LIST')"
                                                v-on:click="openModalModalTable(result.id)">Кўриш
                                        </button>
                                    </td>
                                    <td :class="[result.vatPaidDate?'vat-paid':'vat-unpaid']">
                                        <div class="text-center">
                                            <span v-if="result.vatPaidDate!=null">{{result.vatPaidDate}}</span><br/>
                                            <span v-if="result.vatPaidPaymentOrder!=null">{{result.vatPaidPaymentOrder}}</span>
<!--                                            <input type="checkbox" v-if="!result.vatPaidDate"
                                                   v-model="result.vatPaidEvaluationObjectId"
                                                   @change="setVatPay(result.id, result.qqsAmount, $event)"/>-->

                                            <div class="custom-control custom-checkbox" v-if="!result.vatPaidDate">
                                              <input type="checkbox" class="custom-control-input" :id="'setVatPay' + result.id"
                                                     v-model="result.vatPaidEvaluationObjectId"
                                                     @change="setVatPay(result.id, result.qqsAmount, $event)"/>
                                              <label class="custom-control-label" :for="'setVatPay' + result.id"></label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{{result.unpaid | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                    <td>{{result.creditor | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                </tr>
                            </template>
                            </tbody>
                            <tfoot class="table-footer">
                            <tr v-if="loadingTotal">
                                <loading2 style="" v-if="loadingTotal"></loading2>
                            </tr>
                            <tr v-if="!loadingTotal">
                                <td colspan="4">Жами сумма :<span>{{tableTotalValue.evaluationObjTotal}}</span></td>
                                <td colspan="12"></td>
                                <td>{{tableTotalValue.contractTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="3"></td>
                                <td>{{tableTotalValue.contractTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td></td>
                                <td>{{tableTotalValue.totalAmountTaxPercentQQSSum | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="2"></td>
                                <td>{{tableTotalValue.totalContractQQS | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="2"></td>
                                <td>{{tableTotalValue.peidTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td colspan="3"></td>
                                <td colspan="1"></td>
                                <td>{{tableTotalValue.debtorTotal | currency('', 2, { thousandsSeparator: ' ' })}}</td>
                                <td>{{tableTotalValue.creditorTotal | currency('', 2, { thousandsSeparator: ' ' })}} </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="text-center">
                        <div class="loader mt-5 mb-5" v-if="loading"></div>
                        <span class="no-data mt-5 mb-5"
                              v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
                    </div>
                    <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                        <div class="col-12 pt-3 pb-3">
                            <b-pagination :total-rows="results.total" v-model="filter.page.page"
                                          :per-page="filter.page.size" @change="onPageChange">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PaymentDocumentEditModal/>
    </div>

</template>


<script>
    import Datepicker from 'vuejs-datepicker';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import {formatDate, parseDate, format_date} from '@/shared/utils';
    import Modal from '@/components/Modal.vue';
    import PaymentDocumentEditModal from '@/views/accounting/PaymentDocumentEditModal';
    import VatPaymentModal from '@/views/accounting/VatPaymentModal';
    import Loading2 from '@/views/Loading2';

    // export const
    export default {
        template: '#doc-modal-template',
        name: "LegalAccountingBuilding",
        components: {
            'b-pagination': bPagination,
            Datepicker,
            Modal,
            PaymentDocumentEditModal: PaymentDocumentEditModal,
            VatPaymentModal,
            Loading2
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null,
                organization: this.$t("accounting.account.organization"),
                customers: [],
                evlObjectTypes: [],
                showModal: false,
                showModalTable: false,
                show: false,
                newItem: {
                    paymentDocumentDate: null,
                    price: 0,
                    paymentDocumentNumber: null,
                    realEstateId: null,
                },
                modolTables: [],
                province: {},
                region: {},
                provinces: [],
                regions: [],
                tableTotalValue: [],
                cadastreSections: [],
                employees: [],
                organizationListValue: {},
                vatPay: {
                    total: 0,
                    evaluationObjectIds: [],
                    objectType: "Building"
                },
                loadingTotal: true,
                regionalLeaderProvince: null
            }
        },
        methods: {
            searchByFilter() {
                this.filter.page.page = 1;
                this.initList();
                this.initTableTotal();
            },

            initList() {
                const vm = this;

                const regionalLeader = vm.$store.state.profile.regionalLeader;
                if (regionalLeader){
                    const regionalLeaderProvince = regionalLeader.userProvinces[0];
                    vm.filter.province = regionalLeaderProvince;
                    vm.regionalLeaderProvince = regionalLeaderProvince;
                    vm.filter.placeCreation = vm.regionalLeaderProvince!=null;
                }
                this.filter.startDate = formatDate(this.filter.startDate);
                this.filter.endDate = formatDate(this.filter.endDate);
                this.filter.startDate = parseDate(this.filter.startDate);
                this.filter.endDate = parseDate(this.filter.endDate);
                this.loading = true;

                this.init();
                this.$http.post('/account/building/list', this.filter).then(res => {
                    vm.results = res.data;
                    console.log(vm.results)
                    vm.loading = false;
                }, err => {
                    console.log(err);
                    vm.loading = false;
                });

            },
            format_date(value){
                if (value) {
                    return format_date(value)
                }
                return null;
            },
            init() {
                const vm = this;
                const promises = [
                    this.$http.get('province/init')
                ];
                Promise.all(promises).then(function (values) {
                    const initData = values[0].data;
                    vm.provinces = initData.provinces;
                });
            },
            initTableTotal() {
                const vm = this;

                const regionalLeader = vm.$store.state.profile.regionalLeader;
                if (regionalLeader){
                    const regionalLeaderProvince = regionalLeader.userProvinces[0];
                    vm.filter.province = regionalLeaderProvince;
                    vm.regionalLeaderProvince = regionalLeaderProvince;
                    vm.filter.placeCreation = vm.regionalLeaderProvince!=null;
                }

                this.loading = true;
                this.loadingTotal = true;
                this.$http.post('/account/building/list/data/total', this.filter)
                    .then(res => {
                        this.loadingTotal = false;
                        console.log(res);
                        const initData = res.data;
                        vm.tableTotalValue = initData.dataTotal;
                        vm.loading = false;
                    },(err) => {
                        console.log(err);
                        vm.loading = false;
                    })
            },
            getOrganizationType() {
                const vm = this;
                this.loading = true;
                this.$http.get('/account/organizationType')
                    .then(res => {
                        const initData = res.data;
                        if (!vm.filter.organizationType && initData.data && initData.data.length < initData.total && initData.data.length > 0) {
                            vm.filter.organizationType = initData.data[0].code;
                            vm.organization = initData.data[0].displayName
                        }
                        vm.organizationListValue = initData;
                        this.initList();
                        vm.loading = false;
                    }, (err) => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            openModal(id) {
                this.newItem.paymentDocumentDate = '';
                this.newItem.price = 0;
                this.newItem.paymentDocumentNumber = '';
                this.newItem.realEstateId = id;
                this.showModal = true;
            },
            closeModal() {
                this.showModal = false;
            },
            saveModal: function () {
                this.loading = true;
                if (this.newItem.price > 0 && this.newItem.paymentDocumentNumber != "" && this.newItem.paymentDocumentDate != "") {
                    this.$http.post('/payment/documents/save', this.newItem).then(res => {
                        this.showModal = false;
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('accounting.accountMessages.success'),
                            type: 'success'
                        });
                        this.loading = false;
                        console.log(res.data);//todo tegmanglar
                        this.initList();
                    }, err => {
                        this.showModal = false;
                        this.loading = false;
                        console.log(err);
                    });
                } else {
                    this.showModal = false;
                    this.$swal({
                        title: this.$t('messages.common.error'),
                        text: this.$t('accounting.accountMessages.error'),
                        type: 'error'
                    });
                    this.loading = false;
                }
            },

            openModalModalTable(id) {
                this.newItem.realEstateId=id;
                this.$http.get('/payment/documents/building/list/' + id)
                    .then(res => {
                        if (!res.data.code) {
                            this.newItem = res.data;
                            this.showModalTable = true;
                        }
                    }, err => {
                        console.log(err);
                    });

            },

            showPaymentDocumentEditModal(data) {
                this.showModalTable = false;
                this.$eventBus.$emit('showPaymentDocumentEditModal', data);
            },

            closeModalTable() {
                this.showModalTable = false;
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            onProvinceGetRegionsChange() {
                let regions = [];
                if (this.filter.province && this.filter.province.id && this.provinces && this.provinces.length > 0) {
                    this.provinces.forEach((province) => {
                        if (province.id === this.filter.province.id) {
                            regions = province.regions;
                        }
                    });
                }
                this.regions = regions;
                // this.filter.region = null;
                this.searchByFilter();
            },
            onOrganizationTypeChange() {
                let organization =null;
                if (this.filter.organizationType==null || this.filter.organizationType==='') {
                    this.$delete(this.filter, 'organizationType');
                }
                if (this.filter.organizationType && this.organizationListValue.data && this.organizationListValue.data.length > 0) {
                    this.organizationListValue.data.forEach((organizationListValue) => {
                        if (organizationListValue.code === this.filter.organizationType) {
                            organization = organizationListValue.displayName;
                        }
                    });
                }
                this.organization = organization;
                this.searchByFilter();
            },

            reportXslx: function () {
                this.$http.post('/getAccountingReportBuildingExcel/xls/FITMENT_REPORT_VALUABLE_XLS_BUX/',this.filter, {responseType: 'arraybuffer'})
                    .then(res => {
                        let blob = new Blob([res.data], {type: 'application/xlsx'});
                        let link = document.createElement("a");
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'Xisobot.xlsx';
                        link.click();
                    }, err => {
                        console.log(err);
                    });
            },
            setVatPay(id, qqsAmount, $event) {
                qqsAmount = parseFloat(qqsAmount);
                const value = $event.target.checked;
                var index = this.vatPay.evaluationObjectIds.indexOf(value);
                if (value) {
                    if (index === -1) {
                        this.vatPay.evaluationObjectIds.push(id);
                        this.vatPay.total+=qqsAmount;
                    }
                } else {
                    this.vatPay.evaluationObjectIds.splice(index, 1);
                    this.vatPay.total-=qqsAmount;
                }
                console.log(this.vatPay);
            },
            openVatPaymentModal: function () {
                this.$eventBus.$emit('showVatPaymentModal', {vatPay: this.vatPay});
            },
            getOpenLink(result) {
                return '/real-estate/view/' + result.id;
            },

        },
        created() {
            // this.initList();
            var d = new Date();
            var currMonth = d.getMonth();
            var currYear = d.getFullYear();
            this.filter.startDate = new Date(currYear, currMonth, 1);
            this.filter.endDate = new Date(currYear, currMonth, d.getDate());
            this.filter.paymentStatus = "ALL";

            this.getOrganizationType();
            this.initTableTotal();

            this.$eventBus.$on('LegalAccountingBuilding', (data) => {
                console.log(data);
                // this.initList();
                this.getOrganizationType();
                this.initTableTotal();
            });
        }
    }
</script>

<style scoped>
    .scroll-card-body {
        overflow-x:scroll;
        overflow-y:visible;
    }


    td {
        border-top: 1px solid #dee2e6;
    }

    th, td {
        padding: .5rem;
        /*cursor: col-resize;*/
    }

    .vat-paid {
        background-color: #abc41c;
    }

    .vat-unpaid {
        background-color: transparent;
    }


</style>
